import { createHmac } from 'crypto';

export const sha256 = (data) => {
    const secret = "tresh!1233";
    const hash = createHmac('sha256', secret)
        .update(data)
        .digest('hex');
    return hash;
}